import React, { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import Header from "../../layout/Header/Header";
import { MenuCard, MenuHeader, MenuSection } from "../../MenuCard";

const ITEMS = [
  { type: "section", label: "Maquila" },
  { label: "Salidas a Maquila", icon: "fas fa-sign-out-alt", color: "#f59e0b", bg: "#fffbeb", href: "/ListadoProcesosSalida", desc: "Envio de piezas al maquilero", perm: "menu_procesos" },
  { label: "Entradas de Maquila", icon: "fas fa-sign-in-alt", color: "#10b981", bg: "#f0fdf4", href: "/ListadoProcesosEntrada", desc: "Recepcion de piezas maquiladas", perm: "menu_procesos" },
  { type: "section", label: "Seguimiento de Produccion" },
  { label: "Tracking Mexico", icon: "fas fa-clipboard-check", color: "#0ea5e9", bg: "#f0f9ff", href: "/SeguimientoMX", desc: "Checklist de OC: etiquetas, ficha, GS1, FOB", perm: "menu_procesos" },
  { label: "Tracking China", icon: "fas fa-globe-asia", color: "#f43f5e", bg: "#fff1f2", href: "/SeguimientoChina", desc: "Checklist por modelo: muestras, tags, contenedor", perm: "menu_procesos" },
  { type: "section", label: "Captura" },
  { label: "Nueva Salida", icon: "fas fa-cut", color: "#3b82f6", bg: "#eff6ff", href: "/ProcesosSalidaCreate", desc: "Mandar piezas de un pedido a maquila", perm: "menu_procesos" },
  { label: "Nueva Entrada", icon: "fas fa-dolly", color: "#8b5cf6", bg: "#f5f3ff", href: "/ProcesosEntradaCreate", desc: "Recibir contra una salida", perm: "menu_procesos" },
];

function BotonesProduccion() {
  const { user } = useContext(AuthContext);
  return (
    <>
      <Header />
      <div className="card container">
        <MenuHeader icon="fas fa-industry" color="#6366f1" bg="#eef2ff" title="Produccion" subtitle="Maquila: salidas y entradas de procesos" />
        {user.menu_procesos ? (
          <div className="row">
            {ITEMS.map((r, i) =>
              r.type === "section"
                ? <MenuSection key={i} title={r.label} />
                : <MenuCard key={i} {...r} enabled={!!user[r.perm]} />
            )}
          </div>
        ) : <p style={{ color: "#94a3b8", fontSize: "0.82rem" }}>Sin acceso.</p>}
      </div>
    </>
  );
}

export default BotonesProduccion;
